// // src/contexts/AuthContext.js
// import React, { createContext, useState, useContext } from 'react';

// // Create the context object
// export const AuthContext = createContext({
//   apiJwt: null,        // The token itself
//   setApiJwt: () => {}, // A function to update the token
// });

// // Create the provider component that will wrap your app
// export const AuthProvider = ({ children }) => {
//   const [apiJwt, setApiJwt] = useState(null);
//   const value = { apiJwt, setApiJwt };

//   return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
// };

// // Create a custom hook for easy access to the context
// export const useAuth = () => useContext(AuthContext)

import React, { createContext, useState, useContext } from 'react';

// Create the context object
export const AuthContext = createContext({
  apiJwt: null,
  setApiJwt: () => {},
});

// Create the provider component that will wrap your app
export const AuthProvider = ({ children }) => {
  const [apiJwt, setApiJwt] = useState(null);
  const value = { apiJwt, setApiJwt };

  // FIX 1: The 'value' prop was missing. This is the most critical bug.
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

// Create a custom hook for easy access to the context
export const useAuth = () => useContext(AuthContext);

export const createApiClient = (apiJwt) => {
  const request = async (endpoint, options = {}) => {
    // We assume the JWT is required for all calls.
    if (!apiJwt) {
      throw new Error("API call failed: No authentication token provided.");
    }

    const defaultHeaders = {
      'Content-Type': 'application/json',
      // FIX 2: Use the actual apiJwt token in the header.
      'Authorization': `Bearer ${apiJwt}`,
    };

    const config = {
      ...options,
      headers: {
        ...defaultHeaders,
        ...options.headers,
      },
      credentials: 'include',
    };

    try {
      const response = await fetch(endpoint, config);

      if (response.status === 401) {
        // You might want to add logic here to auto-logout the user
        throw new Error("Unauthorized (401)");
      }

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: 'Failed to parse error response.' }));
        throw new Error(errorData.message || `API Error: ${response.status}`);
      }
      
      if (response.status === 204) {
          return null;
      }

      // FIX 3: Make the client flexible. Don't assume JSON.
      // The component that makes the call will decide how to handle the response body.
      return response; 

    } catch (error) {
      console.error(`API request to ${endpoint} failed:`, error);
      throw error;
    }
  };

  return {
    // The methods now return the raw response object.
    get: (endpoint) => request(endpoint, { method: 'GET' }),
    post: (endpoint, body) => request(endpoint, { method: 'POST', body: JSON.stringify(body) }),
  };
};

export const fetchInitialJwt = async () => {
    const jwtUrl = process.env.REACT_APP_JWT_URL;
    const username = process.env.REACT_APP_JWT_USERNAME;
    const password = process.env.REACT_APP_JWT_PASSWORD;

    const resp = await fetch(jwtUrl, {
        method: 'POST',
        // FIX 4: Use the actual username and password variables.
        headers: { 'Authorization': 'Basic ' + btoa(`${username}:${password}`) }
    });

    if (!resp.ok) throw new Error("Failed to get initial JWT");
    
    const data = await resp.json();
    return data.token;
};